import RemoveExamModal from './RemoveExamModal';

export default RemoveExamModal;
